import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/** items = [{name, href}] — last item is not linked. */
export default function Breadcrumbs({ items = [] }) {
    return (
        <nav aria-label="Breadcrumb" className="mb-8 text-xs font-mono tracking-wider text-muted" data-testid="breadcrumbs">
            <ol className="flex flex-wrap items-center gap-2">
                {items.map((it, i) => {
                    const last = i === items.length - 1;
                    return (
                        <li key={it.href + i} className="flex items-center gap-2">
                            {last ? (
                                <span className="text-ink/80">{it.name}</span>
                            ) : (
                                <Link to={it.href} className="hover:text-ink link-underline">{it.name}</Link>
                            )}
                            {!last && <ChevronRight className="w-3 h-3 opacity-60" />}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
